import axios from '@/libs/http'

/**
 * 获取店员技能申请信息列表
 */
export const getCategoryList = () => {
    return axios.request({
        url: '/s/c/category/examineList',
        method: 'GET'
    })
}

/**
 * 获取店员技能申请信息详细内容
 */
export const getCategoryExamine = (id) => {
    return axios.request({
        url: '/s/c/category/getCategoryExamine',
        params: {
            id: id
        },
        method: 'GET'
    })
}

/**
 * 提交店员审核申请
 */
export const applyCategoryExamine = (categoryExamineId, categoryId, grade, content) => {
    let data = new URLSearchParams()
    data.append("categoryExamineId", categoryExamineId != null ? categoryExamineId : '')
    data.append("categoryId", categoryId != null ? categoryId : '')
    data.append("grade", grade)
    data.append("content", content)
    return axios.request({
        url: '/s/c/category/applyCategoryExamine',
        data,
        method: 'POST'
    })
}

/**
 * 获取默认模板
 */
export const getDefaultCategory = () => {
    return axios.request({
        url: '/s/c/category/getDefaultCategory',
        method: 'get'
    })
}

/**
 * 根据分类组别id查询对应的分类列表
 */
export const getCategoryListByGroupId = (groupId) => {
    let data = new URLSearchParams()
    data.append("groupId", groupId)
    return axios.request({
        url: '/s/c/category/getCategoryListByGroupId',
        data,
        method: 'post'
    })
}
